import script from "./PergantianSioPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PergantianSioPage.vue?vue&type=script&setup=true&lang=js"

import "./PergantianSioPage.vue?vue&type=style&index=0&id=4d125e22&scoped=true&lang=css"
import "./PergantianSioPage.vue?vue&type=style&index=1&id=4d125e22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d125e22"]])

export default __exports__